import { useEffect, useState } from "react";

export interface ImageSize {
  width: number;
  height: number;
}

/** Probe the natural pixel size of an image URL. Resolves to {0, 0} until the
 *  browser has decoded it; callers should render the image at its natural
 *  size once non-zero values arrive. */
export function useImageSize(url: string | undefined): ImageSize {
  const [size, setSize] = useState<ImageSize>({ width: 0, height: 0 });

  useEffect(() => {
    if (!url) {
      setSize({ width: 0, height: 0 });
      return;
    }
    let cancelled = false;
    const img = new Image();
    img.onload = () => {
      if (cancelled) return;
      setSize({ width: img.naturalWidth, height: img.naturalHeight });
    };
    img.onerror = () => {
      if (cancelled) return;
      setSize({ width: 0, height: 0 });
    };
    img.src = url;
    return () => {
      cancelled = true;
    };
  }, [url]);

  return size;
}